import { DocumentReference } from "@angular/fire/firestore";

export interface FilterModel {
    categories: {id: string, name: string,ref:DocumentReference}[];
    breeds: {category:DocumentReference,id:string,name:string, ref:DocumentReference}[];
    ageRange: { minAge: number, maxAge: number }
}

export class Convert {
    public static toFilterModel(json: string): FilterModel {
        return JSON.parse(json);
    }

    public static filterModelToJson(value: FilterModel): string {
        return JSON.stringify(value);
    }

    public static getDefaultFilterModel(): FilterModel {
        return {
            categories: [],
            breeds: [],
            ageRange: { minAge: 0, maxAge: 100 }
        }
    }
}
